
class Const {
    ERROR_COLOR = "rgb(255, 235, 235)";
    RESULT_SUCCESS = 'SUCCESS';
    START_TIMES = [
        { id: "7", value: "7時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "8", value: "8時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "9", value: "9時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "10", value: "10時台", category: "スタート時刻", class: "start_time", checked: false },
        { id: "11", value: "11時台以降", category: "スタート時刻", class: "start_time", checked: false }
    ];
    VERSION = "1.1";

    // ゴルフ1人予約
    GOLF_SOLO_EXCLUDED = ["801" /* グランディ鳴門ゴルフクラブ３６ */, "802" /* ・グランディ浜名湖ゴルフクラブ */, "803" /* ・グランディ那須白河ゴルフクラブ */, "804" /* ・グランディ軽井沢ゴルフクラブ */]
    // 本番ドメイン
    RELEASE_PATH = "https://rsv.rtg.jp";
    // SGドメイン
    SG_PATH = "https://s.rsv.rtg.jp";
    // STドメイン
    ST_PATH = "https://t.rsv.rtg.jp";

    // 会員制ホテル
    MAX_ROOM_CAPACITY = 5
    MAX_MEAL_CAPACITY = 15;
    SIMPLE_STAY_PLAN_CD = "ZZZZZ1";
    GENERAL_CONTRACT_NO = "0099999981"
    MASTER_CONTRACT_NO = "0099981001";
    CHANGEABLE_TERM = 3;
    IMPORTED_CHANGEABLE_TERM = 1;
    COURSE_START_LIMIT = "1900-01-01";
    COURSE_END_LIMIT = "2099-12-31";
    MAX_IMPORTED_CAPACITY = 8;
    DISP_PRICE_CODE = ["0198"]

    // 全国旅行支援対象コード
    TRAVEL_SUPPORT_CODE = "0199"
    SHISETSU_CODE_TOBA = ["201" /* エクシブ鳥羽 */, "205" /* エクシブ鳥羽アネックス */, "225" /* エクシブ鳥羽別邸 */];
    SHISETSU_CODE_NARUTO = ["211" /* エクシブ鳴門 */, "213" /* エクシブ鳴門 サンクチュアリ・ヴィラ */, "216" /* エクシブ鳴門 サンクチュアリ・ヴィラ ドゥーエ */, "601" /* ザ・ロッジ（エクシブ鳴門内） */];

    // 占有日のモード
    SENYUBI_MODE = 0;
    HOME_FL_MODE = 1;
}


export default new Const();

